import { NullClickStrategy, OnlyFilterActionDisplayStrategy } from '../../components/BPMTable/TableMapperCreator';
import TableCreatorCreator from '../../components/BPMTable/TableCreatorFactory/TableCreatorCreator';
import tableCreatorCreatorFactoryCreator from '../../components/BPMTable/TableCreatorFactory/TableCreatorCreatorFactoryCreator';
import { getBayphonesTableDefinitions } from './BayphoneTableDefinitions';
import { gql } from '@apollo/client';

const tableQuery = gql`
  query Bayphones(
    $orderField: String
    $first: Int
    $last: Int
    $after: String
    $before: String
    $enterpriseId: String
    $email: String
    $firstName: String
    $lastName: String
    $deviceType: String
    $state: String
    $changeReason: String
    $closeReason: String
    $expirationDate: String
    $observation: String
    $createdAt: String
    $updatedAt: String
    $createdBy: String
    $updatedBy: String
    $closedAt: String
    $id: String
  ) {
    bayphonesHistory(
      orderField: $orderField
      first: $first
      last: $last
      after: $after
      before: $before
      enterpriseId: $enterpriseId
      email: $email
      firstName: $firstName
      lastName: $lastName
      deviceType: $deviceType
      state: $state
      changeReason: $changeReason
      closeReason: $closeReason
      expirationDate: $expirationDate
      observation: $observation
      createdAt: $createdAt
      updatedAt: $updatedAt
      createdBy: $createdBy
      updatedBy: $updatedBy
      closedAt: $closedAt
      id: $id
    ) {
      edges {
        node {
          id
          user {
            id
            sales
            user {
              id
              enterpriseId
              email
              isActive
              dateHired
              firstName
              lastName
            }
            company {
              id
              currency {
                code
                symbol
              }
            }
          }
          deviceType {
            id
            name
          }
          state {
            id
            name
            identifier
          }
          changeReason {
            id
            name
          }
          onHoldReason {
            id
            name
          }
          closeReason {
            id
            name
          }
          claimedAmount
          approvedAmount
          validSince
          closedAt
          expirationDate
          termsFile
          concurTicket
          observation
          createdAt
          updatedAt
          createdBy {
            id
            email
            firstName
            lastName
          }
          updatedBy {
            id
            email
            firstName
            lastName
          }
        }
      }
      count
      pageInfo {
        hasNextPage
        startCursor
        endCursor
      }
    }
  }
`;

const unitQuery = `
    bayphone(id: $id) {
        id
        user {
            id
            sales
            user {
                id
                enterpriseId
                email
                isActive
                dateHired
                firstName
                lastName
            }
            company {
                id
                currency {
                    code
                    symbol
                }
            }
        }
        deviceType {
            id
            name
        }
        state {
            id
            name
            identifier
        }
        changeReason {
            id
            name
        }
        onHoldReason {
            id
            name
        }
        closeReason {
            id
            name
        }
        claimedAmount
        approvedAmount
        expirationDate
        closedAt
        validSince
        termsFile
        concurTicket
        observation
        createdAt
        updatedAt
        createdBy {
            id
            email
            firstName
            lastName
        }
        updatedBy {
            id
            email
            firstName
            lastName
        }
    }
`;

const editMutator = null;
const newMutator = null;
const deleteMutator = null;

const bayphoneQueries = { tableQuery, editMutator, newMutator, deleteMutator, unitQuery };

class UserBayphonesTableCreator extends TableCreatorCreator {
  constructor(filters) {
        super(filters)
  }

  static getId = () => {
        return "UserBayphonesTableCreator"
    }

    getTableCreator = (tableName) => {
        const tableCreator = this.createTableCreator(this.constructor.getId(), tableName, bayphoneQueries, new NullClickStrategy(), new OnlyFilterActionDisplayStrategy())
    tableCreator.setTableFooterItems([]);

    const fieldDefinitions = getBayphonesTableDefinitions(true);
    tableCreator.addDescriptions(fieldDefinitions);

        return tableCreator
    }
}

tableCreatorCreatorFactoryCreator.addTableCreatorCreator(UserBayphonesTableCreator)

export default UserBayphonesTableCreator